import { Check, CloudAlert, LoaderCircle, Search, Settings, X } from 'lucide-react';
import type { MainView, SyncState } from '../types';

interface Props {
  view: MainView;
  syncState: SyncState;
  searchOpen: boolean;
  search: string;
  syncCycle: number;
  onSearchOpen: () => void;
  onSearchChange: (value: string) => void;
  onSearchClose: () => void;
  onSettings: () => void;
}

const titles: Record<MainView, string> = {
  todos: '待辦清單', reminders: '備忘提醒', calendar: '行事曆',
};

export function AppHeader(props: Props) {
  const syncLabel = {
    idle: '', syncing: '同步中…', success: '已同步', error: '同步失敗',
  }[props.syncState];
  const SyncIcon = props.syncState === 'syncing' ? LoaderCircle : props.syncState === 'success' ? Check : CloudAlert;

  return (
    <header className="app-header">
      <div key={props.syncCycle} className={`sync-countdown sync-${props.syncState}`} />
      <div className="top-app-bar">
        {props.searchOpen ? (
          <label className="header-search">
            <Search size={19} aria-hidden="true" />
            <input
              type="search"
              value={props.search}
              onChange={(event) => props.onSearchChange(event.target.value)}
              placeholder={`搜尋${titles[props.view].replace('清單', '')}…`}
              autoFocus
            />
            <button className="icon-button" onClick={props.onSearchClose} aria-label="關閉搜尋" type="button">
              <X size={20} />
            </button>
          </label>
        ) : (
          <div className="header-title-row">
            <h1>{titles[props.view]}</h1>
            {props.syncState !== 'idle' && (
              <span className={`sync-label sync-${props.syncState}`}>
                <SyncIcon size={13} className={props.syncState === 'syncing' ? 'spin' : ''} />
                {syncLabel}
              </span>
            )}
          </div>
        )}
        {!props.searchOpen && (
          <div className="header-actions">
            <button className="icon-button" onClick={props.onSearchOpen} aria-label="搜尋" type="button">
              <Search size={22} />
            </button>
            <button className="icon-button" onClick={props.onSettings} aria-label="設定" type="button">
              <Settings size={22} />
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
